import {
	IGetCredentialsInfo,
	ICreateCredentials,
	IUpdateCredentials,
	IGetPaginatedCredentials,
	ICredentials,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetCredentialsInfo = (credentialID: string): Promise<IGetCredentialsInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v1/CredentialManager/${credentialID}` });
};

const serviceCreateCredentials = (data: ICreateCredentials): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v1/CredentialManager`, data });
};

const serviceUpdateCredentials = (data: IUpdateCredentials): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v1/CredentialManager/${data.id}`, data });
};

const serviceGetPaginatedCredentials = (args: IGetPaginatedCredentials): Promise<AxiosResponse<ICredentials>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v1/CredentialManager/filtered`, data: args });
};

const serviceDeleteCredentials = (customerID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/v1/CredentialManager/${customerID}`,
	});
};

export {
	serviceGetCredentialsInfo,
	serviceCreateCredentials,
	serviceUpdateCredentials,
	serviceGetPaginatedCredentials,
	serviceDeleteCredentials,
};
